var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"a-cover",attrs:{"aria-label":"Panorama viewer"}},[_c('div',{staticClass:"h-full z-0",attrs:{"id":"pano"}})])
}]

export { render, staticRenderFns }